export const painPoints = [
  {
    emoji: '⏰',
    title: 'Narratives written in a rush at end of shift',
    desc: 'Twelve hours on the console, then your CAD notes and narratives still need cleaning up while the oncoming crew is plugging in.',
  },
  {
    emoji: '🔁',
    title: 'Pass-downs that lose the details',
    desc: 'Open incidents, units out of service, safety notes and follow-ups: one missed line and the next shift starts blind.',
  },
  {
    emoji: '🎧',
    title: 'Every call can be reviewed again',
    desc: 'QA and call reviews mean your recordings and CAD entries can be pulled and read again. Be ready.',
  },
  {
    emoji: '📚',
    title: 'Endless protocol and SOP study',
    desc: 'Protocol updates, new SOPs and certification exams on top of a full schedule, with no time to turn them into study material.',
  },
  {
    emoji: '🧑‍🏫',
    title: 'Training new hires while short-staffed',
    desc: 'You are a CTO, a call-taker and a dispatcher at the same time, and the DORs and training paperwork still have to get done.',
  },
  {
    emoji: '🌙',
    title: '12-hour shifts, nights and mandatory overtime',
    desc: 'Rotations, holdovers and forced overtime leave little energy for writing, studying or planning your career.',
  },
];
